import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import UVTTipoSelect from "./UVTTipoSelect.js"

import { Label, Input, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            tipo: data.tipo,
        });
    }

    resetState() {
        this.setState({
            tipo: null,
        })
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.uvt.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Unidad de Vinculación"}
                buttonTitle={"Ver Unidad de Vinculación"}
                buttonIcon={"fa fa-search fa-lg"}

                saveButton={false}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de vinculación</p>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Tipo</Label>
                                <UVTTipoSelect disabled={true} value={this.state.tipo} onChange={(data) => this.setState({ tipo: data.pk })} />
                            </div>
                        </div>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Email</Label>
                                <Input type="text" name="email" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Porcentaje</Label>
                                <Input type="number" name="porcentaje" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_UVT/Detail.js